export default () => ({
  drawer: null,
  menu: 0,
  sub_menu: 0,
  color: 'success',
  image: 'https://asset.nashsemesta.com/images/sitrendi_1.jpg',
})
